<div class="w-full">
  @let currentValue = currentStep();
  <mib-stepper
    class="w-full"
    [class.hidden]="!isBrowserSupported()"
    [displayNext]="currentValue !== 3"
    (stepChange)="handleStepperChange($event)">
    <mib-step title="Information">
      <app-precall-info-step />
    </mib-step>
    <mib-step
      title="Connectivity"
      [canGoNext]="connectivityTestResult()?.status !== 'in_progress'"
      [canGoPrevious]="connectivityTestResult()?.status !== 'in_progress'">
      <app-precall-conectivity-step #connectivityStep />
    </mib-step>
    <mib-step
      title="Quality"
      [canGoNext]="qualityResult()?.status !== 'in_progress'"
      [canGoPrevious]="qualityResult()?.status !== 'in_progress'">
      <app-precall-quality-step #qualityStep (changed)="qualityResult.set($event)" />
    </mib-step>
    <mib-step title="Report">
      <app-precall-report-step #reportStep />
    </mib-step>
    <mib-step-footer>
      @if (
        currentValue === 1 && ['success', 'failed'].includes(connectivityTestResult()?.status || '')
      ) {
        <a (click)="onConnectivityStepRetry()">Retry</a>
      }
      @if (currentValue === 2 && ['success', 'failed'].includes(qualityResult()?.status || '')) {
        <a (click)="onQualityTestRetry()">Retry</a>
      }
      @if (currentValue === 3 && routeSettings()?.report) {
        <a [href]="reportMailTo()"><mib-button mode="outlined">Sent report</mib-button></a>
      }
      @if (!canDisplayTerminate()) {
        <mib-button (click)="onClickTerminate($event)">Close</mib-button>
      }
    </mib-step-footer>
  </mib-stepper>

  <app-browser-not-supported [class.hidden]="isBrowserSupported()" />
</div>

@if (isBrowserSupported() && !micPermission()) {
  <div class="fixed top-0 left-0 w-full h-full bg-black/70 z-10 backdrop-blur-xs">
    <dialog class="mib-dialog absolute top-1/2 left-1/2 -translate-1/2 z-11 flex flex-col gap-2">
      @if (micPermissionState() === 'denied') {
        <h2 class="text-lg">Microphone access was blocked</h2>

        @if (isAndroid()) {
          <!-- Android: no point showing the button, give direct steps -->
          <p>Your browser has blocked microphone access. To fix this:</p>
          <ol class="text-sm list-decimal list-inside flex flex-col gap-1">
            <li>
              Tap the <strong>icon to the left of the web address</strong> (lock or settings icon)
            </li>
            <li>Tap <strong>Permissions</strong></li>
            <li>Set <strong>Microphone</strong> to <em>Allowed</em></li>
          </ol>
        } @else {
          <p class="">Please enable microphone access in your browser settings.</p>

          <p class="text-sm text-gray-500">
            Depending on your browser, the button below might open the permission popup or display
            the permission icon in the address bar.
          </p>

          <mib-button class="mt-4 self-center" (click)="requestMicrophonePermission()">
            <svg mib-microphone-icon></svg>
            Request permission
          </mib-button>
        }
      } @else {
        <h2 class="text-lg">Microphone access required</h2>
        <p>Click below to allow microphone access.</p>
        <mib-button (click)="requestMicrophonePermission()" class="mt-4 self-center">
          <svg mib-microphone-icon></svg>
          Request permission</mib-button
        >
      }
    </dialog>
  </div>
}
